import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {
		employeeInfo: { projects: [] },
		tags: [],
		allEmployees: [],
		usersWithoutPag: [],
		myData: {
			employee: {}
		},
		unlinkedEmployees: []
	},

	actions: {
		fetchAll ({ commit }, { UserType, IsActive, NonDeleted, OrderByName, Page, PerPage, OrderByCreatedDate, OrderByHiringDate }) {
			const urlSearchParams = new URLSearchParams();
			const params = { UserType, IsActive, NonDeleted, OrderByName, Page, PerPage, OrderByCreatedDate, OrderByHiringDate }
			
			Object.keys(params).forEach(param => {
				if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
			});

			return window.axios.get('/users', { 
				params: urlSearchParams
			}).then((response) => {
				return {
					data: response.data,
					total: parseInt(response.headers['x-pagination-total-count'])
				}
			})
		},

		fetchUsersWithoutPag ({ commit }, { isActiveOnly }) {
			return window.axios.get(`/Users/AllUsers/${isActiveOnly}`).then(({ data }) => {
				commit(types.STORE_USER_WITHOUT_PAGINATION, data)
				return data
			})
		},

		fetchById ({ commit }, { id }) {
			return window.axios.get(`/users/${id}`).then(({ data }) => {
				const myData = {
					employee: data.employee.arabicFirstName + data.employee.arabicLastName,
					photo: data.employee.profilePicUrl,
					isSupervisor: data.isSupervisor
				}
				localStorage.setItem('myData', JSON.stringify(myData));
				
				commit(types.STORE_MY_INFO, data)
				return data
			})
		},

		fetchAllEmployees ({ commit }) {
			return window.axios.get('/Users/AllEmployees').then(({ data }) => {
				commit(types.STORE_ALL_EMPLOYEES, data)
				return data
			})
		},

		create ({ commit }, { employeeId, email, username, userType, isActive, password, isSupervisor, workHours, hireDate }) {
			return window.axios.post('/users', { 
				employeeId, email, username, userType, isActive, password, isSupervisor, workHours, hireDate
			}).then((data) => {
				return data
			})
		},

		update ({ commit }, { employeeId, email, username, userType, isDeactivated, password, id, isActive, isSupervisor, hireDate, workHours }) {
			return window.axios.put(`/users/${id}`, { employeeId, email, username, userType, isDeactivated, password, isActive, isSupervisor, hireDate, workHours }).then((data) => {
				return data
			})
		},

		changeStatus ({ commit }, { id }) {
			return window.axios.put(`/users/${id}/toggle`, { 
				headers: {
					'Content-Type': 'application/json'
				}
			}).then((data) => {
				return data
			})
		},
		
		delete ({ commit }, { id }) {
			return window.axios.delete(`/users/${id}`).then((data) => {
				return data
			})
		},

		getEmployeeByEmployeeId ({ commit }, { id }) {
			return window.axios.get(`/Users/employee/${id}`).then((data) => {
				return data
			})
		},

		changePassword ({ commit }, { id, newPassword }) {
			return window.axios.put(`/Users/Password/${id}`, newPassword).then((data) => {
				return FormDataEvent
			})
		},
		fetchEmployeeUnLinked ({ commit }) {
			return window.axios.get('/Users/UnlinkedEmployees').then(({ data }) => {
				commit(types.STORE_UNLINKED_EMPLOYEE, data)
			})
		}
	},

	mutations: {
		// [types.STORE_USERS] (state, employees) {
		// 	state.employees = employees
		// },

		[types.STORE_USER] (state, employeeInfo) {
			state.employeeInfo = employeeInfo
		},
		
		[types.STORE_TAGS] (state, tags) {
			state.tags = tags
		},

		[types.STORE_ALL_EMPLOYEES] (state, allEmployees) {
			state.allEmployees = allEmployees
		},

		[types.STORE_USER_WITHOUT_PAGINATION] (state, usersWithoutPag) {
			state.usersWithoutPag = usersWithoutPag
		},

		[types.STORE_MY_INFO] (state, myData) {
			state.myData = myData
		},

		[types.STORE_UNLINKED_EMPLOYEE] (state, unlinkedEmployees) {
			state.unlinkedEmployees = unlinkedEmployees
		}
	},

	getters: {
		// getUserById: state => id => state.employees.find(c => c.id === id),
		getEmployeeById: state => employeeId => state.employees.find(c => c.employeeId === employeeId),
		getUserByName: state => name => state.employees.find(c => c.name === name),
		getUserByEmployeeId: state => employeeId => state.allEmployees.find(c => c.employeeId === employeeId),
		getUserWithoutPagById: state => id => state.usersWithoutPag.find(c => c.id === id)
	}
}
